module.exports = __webpack_public_path__ + "media/images/brands/marque-opi@2x-4d1f090bec24bf85f091a3d128f0e80d.jpg";